import { AppState } from "store";
import { ReportsFiltersArgs } from "./types";

export const reportsFiltersSelector = ({
  filters,
}: AppState): ReportsFiltersArgs => {
  return filters.reports;
};
